module.exports = __webpack_public_path__ + "static/media/tanque.19f8e328.jpg";